import AppDispatcher from '../utils/AppDispatcher';

import { actions as ActionTypes } from '../constants/PopupConstants';
import GuestApi from '../api/GuestApi';
import PosApi from '../api/PosApi';

import NotificationActions from './NotificationActions';

import UserStore from '../stores/UserStore';

var PopupActions = {

    open:(page, data, guest) => {
        AppDispatcher.dispatch({
            actionType: ActionTypes.OPEN,
            page  : page,
            data  : data,
            guest : guest
        });
    },

    close:() => {
        AppDispatcher.dispatch({
            actionType: ActionTypes.OPEN,
            page : false,
            data : false,
            guest : false
        });
    },

    patientJournal:(guest) => {
        var formData        = UserStore.getApiData();
        formData.NoteSource = 'Dispensary';
        formData.Guest_id   = guest.Guest_id;

        var promise         = GuestApi.viewPatientNotes(formData);

        promise.then(res => {

            if (!res.Result)
                PopupActions.notification({
                    message : res.Message,
                    type    : 'error'
                })
            else {
                AppDispatcher.dispatch({
                    actionType: ActionTypes.OPEN,
                    page : 'journal',
                    data : res.Data,
                    guest : guest
                });
            }
        });
    },

    viewProfile:(guest) => {
        AppDispatcher.dispatch({
            actionType: ActionTypes.OPEN,
            page : false,
            data : false,
            guest : false
        });
        AppDispatcher.dispatch({
            actionType: ActionTypes.OPEN,
            page : 'profile',
            data : false,
            guest : guest
        });
    },

    addBulk:(guest, item) => {
        AppDispatcher.dispatch({
            actionType: ActionTypes.OPEN,
            page : 'bulk',
            data : item,
            guest : guest
        });
    },

    openDelivery:(guest, shipmentId) => {
        AppDispatcher.dispatch({
            actionType: ActionTypes.OPEN_DELIVERY,
            page  : 'delivery',
            shipmentId  : shipmentId,
            guest : guest
        });
    },
    openRemotePay:(guest, shipmentId) => {
        AppDispatcher.dispatch({
            actionType: ActionTypes.OPEN,
            page  : 'remotepay',
            data  : { shipmentId },
            guest : guest
        });
    },    
    notification({message, type}) {
        setTimeout(() => {
            NotificationActions.addNotification({
                type : type,
                body : message
            });
        }, 100);
    }
}

export default PopupActions;


// WEBPACK FOOTER //
// ./ui_src/app/actions/PopupActions.jsx